module.exports = __webpack_public_path__ + "static/media/p1.08ceb444.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/p1.jpg
// module id = 135
// module chunks = 0